export function isRemember() {
    const remember = localStorage.getItem("remember");
    return remember === "1";
}
